module.exports = "/_next/static/images/banner-app-download-uscis-update-c874d30a77c59a65f285622827bafd41.png";